import * as React from 'react';
import { observer } from 'mobx-react';

import { Button } from 'shared/newComponents/buttons';
import { ButtonSize } from 'shared/newEntities/components/Button';
import { ComponentType } from 'shared/entities/components/Component';
import Typography from 'shared/newComponents/Typography';
import {
  TypographySize,
  TypographyType
} from 'shared/newEntities/components/Typography';
import { WidgetChannelModel } from 'shared/models/channel/widget';
import Snippet from 'shared/newComponents/Snippet';
import TypedTransComponent from 'shared/components/TypedTransComponent';
import TextHighlighter from 'shared/components/TextHighlighter';
import { useTypedTranslation } from 'shared/entities/localization';

import './WidgetInstall.modules.scss';

type Props = {
  store: WidgetChannelModel | null;
  onCheckInstall: () => void;
  isLoading?: boolean;
};

const WidgetInstall: React.FC<Props> = ({
  store,
  onCheckInstall,
  isLoading
}) => {
  const { t } = useTypedTranslation('newContainers');
  const handleCheckInstall = React.useCallback(() => {
    onCheckInstall();
  }, [onCheckInstall]);

  if (!store) {
    return null;
  }

  return (
    <div styleName="widget-install">
      <Snippet
        code={store.generatedSnippet}
        Instruction={
          <>
            <Typography
              fontType={TypographyType.text}
              fontSize={TypographySize.s}
            >
              <TextHighlighter
                text={t(
                  'ChannelsModal.ChannelForm.Widget.Install.snippet.first'
                )}
                query={['</body>']}
                highlightWithColor={false}
              />
            </Typography>
            <Typography
              fontType={TypographyType.text}
              fontSize={TypographySize.s}
            >
              {t('ChannelsModal.ChannelForm.Widget.Install.snippet.second')}
            </Typography>
          </>
        }
      />
      <Typography fontType={TypographyType.text} fontSize={TypographySize.s}>
        <TypedTransComponent
          i18nKey="ChannelsModal.ChannelForm.Widget.Install.caption"
          ns={'newContainers'}
          components={{
            br: <br />,
            b: <b />
          }}
        />
      </Typography>
      <Button
        size={ButtonSize.lg}
        type={ComponentType.button}
        onClick={handleCheckInstall}
        isLoading={isLoading}
        disabled={isLoading}
        fullWidth
      >
        {(t) =>
          t('ChannelsModal.ChannelForm.Widget.Install.button', {
            ns: 'newContainers'
          })
        }
      </Button>
    </div>
  );
};

export default observer(WidgetInstall);
